import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/category/movie", label: "电影频道" },
  { to: "/category/tv", label: "电视剧频道" },
  { to: "/category/variety", label: "综艺频道" },
  { to: "/news", label: "影视资讯" },
];

const aboutLinks = [
  { to: "/about", label: "关于我们" },
  { to: "/favorites", label: "我的收藏" },
  { to: "/history", label: "浏览记录" },
  { to: "/category", label: "全部作品" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">糖心传媒</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-100/80">
              汇聚最新影视作品与丰富资讯，涵盖电影、电视剧及综艺内容，为每一位影视爱好者提供便捷、纯粹的浏览体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <span>频道导航</span>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-background-100/80 transition-colors hover:text-accent-400"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <span>用户中心</span>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {aboutLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-background-100/80 transition-colors hover:text-accent-400"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <span>友情链接</span>
            </h4>
            <ul className="mt-4 space-y-2.5">
              <li className="text-sm text-background-100/80">影视观察周刊</li>
              <li className="text-sm text-background-100/80">光影放映室</li>
              <li className="text-sm text-background-100/80">剧集情报站</li>
              <li className="text-sm text-background-100/80">综艺前线</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-100/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-100/70">
            © 2025 糖心传媒 · 本站内容与影视信息均为虚构演示数据，仅供设计展示使用
          </p>
          <p className="text-xs text-background-100/70">
            演示页面不提供真实播放与下载功能
          </p>
        </div>
      </div>
    </footer>
  );
}